var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{ref:_vm.refName,staticClass:"dashboard-graph",attrs:{"height":_vm.chartHeight,"width":_vm.chartWidth,"options":_vm.options,"series":_vm.chartOptions.series,"categories":_vm.chartOptions.categories}})
}
var staticRenderFns = []

export { render, staticRenderFns }